import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import CircularProgress from '@mui/material/CircularProgress';

const BUTTON_STYLES = {
    primary: {
        base: '!bg-primary !text-white dark:!text-[#18181B]',
        hover: 'hover:!bg-section-title ',
    },
    widget: {
        base: 'bg-[#1A8A7E] text-white',
        hover: 'hover:bg-[#15685F] ',
    },
    secondary: {
        base: '!bg-secondary !text-primary',
        hover: 'hover:bg-[#D1D1D6] dark:hover:bg-[#51525C]',
    },
    success: {
        base: '!bg-success text-white',
        hover: 'hover:bg-[#418D0B] dark:hover:bg-[#299059]',
    },
    error: {
        base: '!bg-error text-white',
        hover: 'hover:bg-[#C3271C] dark:hover:bg-[#B22218]',
    },
    failed: {
        base: '!bg-failed text-white',
        hover: 'hover:bg-[#C4701C]',
    },
    otherRedText: {
        base: '!bg-secondary !text-delete',
        hover: 'hover:bg-[#D1D1D6] dark:hover:bg-[#51525C]',
    },
    otherBordered: {
        base: 'border border-black text-black bg-white dark:border-white dark:text-white dark:bg-black',
        hover: 'hover:bg-gray-100 dark:hover:bg-gray-900',
    },
    custom: {
        base: '',
        hover: '',
    },
};

const DISABLED_STYLE = 'bg-[#3F3F46] opacity-50 text-white dark:bg-[#70707B] cursor-not-allowed';

const JunoButton = ({
    type = 'primary',
    loading = false,
    disabled = false,
    children,
    onClick,
    className,
    dataE2e = '',
}) => {
    const style = BUTTON_STYLES[type] || {};

    return (
        <button
            className={clsx(
                'w-full !h-11 uppercase !rounded-md px-4 py-2 font-medium flex items-center justify-center gap-2 transition-colors duration-200',
                disabled ? DISABLED_STYLE : [style.base, style.hover],
                className,
            )}
            onClick={onClick}
            disabled={disabled || loading}
            data-e2e={dataE2e}>
            {/* {loading && <CircularProgress size={18} color="inherit" />} */}
            {children}
            {loading && <CircularProgress size={16} color="inherit" />}
        </button>
    );
};

JunoButton.propTypes = {
    type: PropTypes.oneOf(Object.keys(BUTTON_STYLES)),
    loading: PropTypes.bool,
    disabled: PropTypes.bool,
    children: PropTypes.node.isRequired,
    onClick: PropTypes.func,
    className: PropTypes.string,
};

export default JunoButton;
